export const APP_STORE_LINK = "https://apps.apple.com/in/app/quilt-wellness/id6761006350"; // Placeholder link, change to actual App Store link
export const GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.quiltwellness.app"; // Placeholder link, change to actual Google Play link
